var History = require('../../../core/history/history');

module.exports = _.extend({
  initialize: $.noop,
  undo: function () { History.undo(); },
  redo: function () { History.redo(); },
  restore: function (svgString) { History.restore(svgString); }
}, Backbone.Events);
